import type {QueryClient} from "@tanstack/react-query";
import {CustomerReferenceError} from "@sakura-grp/database/errors";
import {toast} from "@sakura-grp/ui/sonner";

export function handleCustomerReferenceError(error: unknown, client: QueryClient): void {
  if (!(error instanceof CustomerReferenceError) || error.handled) return;
  error.handled = true;
  if (error.customerId) client.removeQueries({queryKey: ["customer-detail", error.customerId]});
  for (const key of ["tab-customers", "tab-counts", "customer-detail", "customer-activities", "activities", "activity-stats", "announcements"]) {
    void client.invalidateQueries({queryKey: [key]});
  }
  if (error.code === "SK041") {
    toast.error("このお客様は別のお客様にまとめられました", {description: "最新の情報に更新します"});
  } else {
    toast.error("このお客様は削除されています");
  }
  window.dispatchEvent(
    new CustomEvent(error.code === "SK041" ? "customer-merged" : "customer-deleted", {
      detail: {customerId: error.customerId, mergedInto: error.mergedInto},
    }),
  );
}

export function isHandledCustomerReferenceError(error: unknown): boolean {
  return error instanceof CustomerReferenceError && error.handled;
}
